import { render, staticRenderFns } from "./ForgetForm.vue?vue&type=template&id=8a80990e&scoped=true&"
import script from "./ForgetForm.vue?vue&type=script&lang=js&"
export * from "./ForgetForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetForm.vue?vue&type=style&index=0&id=8a80990e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80990e",
  null
  
)

export default component.exports